import {Selector} from '@ngxs/store';
import {IResponse} from '@interfaces/response';
import {IDevice, IDeviceInfo, IUnapprovedDevice} from '@interfaces/devices';
import {DevicesStateModel} from './devices-state.model';
import {DevicesState} from './devices.state';

export class DevicesSelectors {
  @Selector([DevicesState])
  static getAllSystemDevices(state: DevicesStateModel): number {
    return state.allSystemDevices;
  }

  @Selector([DevicesState])
  static getDevicesPerPage(state: DevicesStateModel): number {
    return state.devicesPerPage;
  }

  @Selector([DevicesState])
  static getDevices(state: DevicesStateModel): IResponse<IDevice> | null {
    return state.devices;
  }

  @Selector([DevicesState])
  static getUnapprovedDevices(state: DevicesStateModel): IResponse<IUnapprovedDevice> | null {
    return state.unapprovedDevices;
  }

  @Selector([DevicesState])
  static getUnapprovedTotal(state: DevicesStateModel): number {
    return state.unapprovedTotal;
  }

  @Selector([DevicesState])
  static getDevicesWithoutGroup(state: DevicesStateModel): IResponse<IDevice> | null {
    return state.devicesWithoutGroup;
  }

  @Selector([DevicesState])
  static getDevicesWithoutGroupTotal(state: DevicesStateModel): number {
    return state.devicesWithoutGroupTotal;
  }

  @Selector([DevicesState])
  static getMobileDevicesMenuStatus(state: DevicesStateModel): boolean {
    return state.mobileDevicesMenuStatus;
  }

  @Selector([DevicesState])
  static getCurrentPage(state: DevicesStateModel): number {
    return state.currentPage;
  }

  @Selector([DevicesState])
  static getDevicesSearch(state: DevicesStateModel): string {
    return state.searchParam;
  }

  @Selector([DevicesState])
  static getDevicesInfo(state: DevicesStateModel): { [key: string]: IDeviceInfo }[] {
    return state.devicesInfo;
  }

  @Selector([DevicesState])
  static getSelectedDevice(state: DevicesStateModel): IDevice | null {
    return state.selectedDevice;
  }

  @Selector([DevicesState])
  static getScreenshot(state: DevicesStateModel): { date: string, scr: string } | null {
    return state.screenshot;
  }

  @Selector([DevicesState])
  static getScreenshotLoading(state: DevicesStateModel): boolean {
    return state.screenshotLoading;
  }
 }
